import React, { useState } from "react";
import "../styles/FormInput.css";

const FormInput = ({ label, name, value, onChange, rows = 1 }) => {
  const [focused, setFocused] = useState(false);

  const handleFocus = () => setFocused(true);
  const handleBlur = () => setFocused(false);

  return (
    <div className={`material-textbox ${focused || value ? "focused" : ""}`}>
      <label className="material-label">{label}</label>
      <textarea
        name={name}
        value={value}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={onChange}
        rows={rows}
      />
    </div>
  );
};

export default FormInput;
